import {
  LayoutDashboard,
  GraduationCap,
  Crown,
  NotebookPen,
  Radio,
  KeyRound,
  ShoppingBag,
  Bell,
  User as UserIcon,
  Users,
  CreditCard,
  BookOpen,
  ShieldCheck,
  BarChart3,
  Settings,
  Copy,
  HelpCircle,
  Megaphone,
  ScrollText,
  Handshake,
  Activity,
  CandlestickChart,
  Plug,
  BookOpenCheck,
  Calculator,
  ShieldAlert,
  SlidersHorizontal,
} from 'lucide-react';

export interface NavItem {
  key: string;
  label: string;
  icon: any;
  path?: string;
  disabled?: boolean;
  feature?: 'kalkulator_lot' | 'harga_pertahanan' | 'request_indikator';
}

export const MEMBER_NAV: NavItem[] = [
  { key: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, path: '/member/dashboard' },
  { key: 'ecourse', label: 'E-Course', icon: GraduationCap, path: '/member/courses' },
  { key: 'vip', label: 'VIP Membership', icon: Crown, path: '/member/vip' },
  { key: 'journal', label: 'Trading Journal', icon: NotebookPen, path: '/member/journal' },
  { key: 'kalkulator-lot', label: 'Kalkulator Lot', icon: Calculator, path: '/member/lot-calculator', feature: 'kalkulator_lot' },
  { key: 'harga-pertahanan', label: 'Harga Pertahanan', icon: ShieldAlert, path: '/member/sustaining-power', feature: 'harga_pertahanan' },
  { key: 'livetrade', label: 'Live Trade', icon: Radio, path: '/member/live-trades' },
  { key: 'signals', label: 'Signal & Mapping', icon: Activity, path: '/member/signals' },
  { key: 'chart', label: 'Chart Live', icon: CandlestickChart, path: '/member/chart' },
  { key: 'indikator', label: 'Akses Indikator', icon: KeyRound, path: '/member/indicator-access', feature: 'request_indikator' },
  { key: 'copytrade', label: 'Join Copytrade', icon: Copy, path: '/member/copytrade' },
  { key: 'orders', label: 'Orders', icon: ShoppingBag, path: '/member/orders' },
  { key: 'notifikasi', label: 'Notifikasi', icon: Bell, path: '/member/notifications' },
  { key: 'help', label: 'Bantuan', icon: HelpCircle, path: '/member/help' },
  { key: 'profil', label: 'Profil', icon: UserIcon, path: '/member/profile' },
];

export const ADMIN_NAV: NavItem[] = [
  { key: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, path: '/admin/dashboard' },
  { key: 'users', label: 'Users', icon: Users, path: '/admin/users' },
  { key: 'vip-mgmt', label: 'VIP Management', icon: Crown, path: '/admin/vip' },
  { key: 'courses', label: 'Courses', icon: BookOpen, path: '/admin/courses' },
  { key: 'orders-payments', label: 'Orders & Payments', icon: CreditCard, path: '/admin/orders' },
  { key: 'livetrade', label: 'Live Trade', icon: Radio, path: '/admin/live-trades' },
  { key: 'signals', label: 'Signal & Mapping', icon: Activity, path: '/admin/signals' },
  { key: 'indicator-access', label: 'Indicator Access', icon: ShieldCheck, path: '/admin/indicator-access' },
  { key: 'copytrade', label: 'Join Copytrade', icon: Copy, path: '/admin/copytrade' },
  { key: 'journal-reports', label: 'Trading Journal Reports', icon: BarChart3, path: '/admin/trading-journals' },
  { key: 'faq-help', label: 'FAQ & Help', icon: HelpCircle, path: '/admin/faq-help' },
  { key: 'ads', label: 'Ads & Pengumuman', icon: Megaphone, path: '/admin/ads' },
  { key: 'payment-gateway', label: 'Payment Gateway', icon: CreditCard, path: '/admin/payments-gateway' },
  { key: 'notifikasi', label: 'Kirim Notifikasi', icon: Bell, path: '/admin/notifications' },
  { key: 'activity-log', label: 'Log Aktivitas', icon: ScrollText, path: '/admin/activity-logs' },
  { key: 'brokers', label: 'Broker Rekanan', icon: Handshake, path: '/admin/brokers' },
  { key: 'mcp-connector', label: 'Konektor Claude (MCP)', icon: Plug, path: '/admin/mcp-connector' },
  { key: 'manual-book', label: 'Manual Book', icon: BookOpenCheck, path: '/admin/manual-book' },
  { key: 'feature-access', label: 'Akses Menu Tools', icon: SlidersHorizontal, path: '/admin/feature-access' },
  { key: 'settings', label: 'Settings', icon: Settings, path: '/admin/settings' },
];

export const ADMIN_NAV_END = true;
